import { CheckIcon, TicketIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import React, { useRef, useCallback } from 'react'

const Seat = ({ seat, handleClick, seatId }) => {
  const buttonRef = useRef(null)
  
  const handleSeatClick = useCallback((e) => {
    // Don't allow clicks while loading
    if (seat.loading) return
    
    // Allow clicks if seat is available OR in basket (for deselection) OR marked for removal (for re-selection)
    const isClickable = seat.available || seat.inBasket || seat.markedForRemoval
    if (!isClickable) return
    
    // Call the parent handler to update the model
    handleClick()
  }, [seat.loading, seat.available, seat.inBasket, seat.markedForRemoval, handleClick])
  
  return (
    <button
      ref={buttonRef}
      className={clsx(
        'w-5 h-5 rounded-full flex items-center justify-center',
        'absolute overflow-visible',
        seat.loading ? 
          'bg-gray-300 dark:bg-gray-600 opacity-50 cursor-not-allowed' :
          seat.markedForRemoval ?
            'bg-green-600 hover:bg-green-700 cursor-pointer' :
            seat.inBasket ? 
              'bg-blue-600 text-white cursor-pointer hover:bg-blue-700 ring-2 ring-blue-400' :
              seat.available ?
                'bg-green-600 hover:bg-green-700 cursor-pointer' :
                'bg-gray-400 opacity-60 cursor-not-allowed'
      )}
      title={seat.loading ? 'Loading...' : `${seat.name}${seat.inBasket && !seat.markedForRemoval ? ' (Selected)' : seat.markedForRemoval ? ' (Removing...)' : ''}`}
      style={{ left: seat.x, top: seat.y }}
      disabled={seat.loading || (!seat.available && !seat.inBasket)}
      onClick={handleSeatClick}
    >
      {seat.inBasket && !seat.markedForRemoval && (
        <TicketIcon className='w-4 h-4 -rotate-12 text-white fill-white' />
      )}
    </button>
  )
}

export default React.memo(Seat)
